<!-- components/tweet/TweetMediaGrid.vue -->
<template>
  <div class="relative">
    <!-- Single item - centered -->
    <div v-if="mediaItems.length === 1 && mediaItems[0]" class="w-full flex justify-center">
      <div class="relative w-full max-w-3xl">
        <TweetMediaItem
          :item="mediaItems[0]"
          class="rounded-2xl overflow-hidden"
          @click="openGallery(0)"
          @play="$emit('videoPlay', 0)"
        />
      </div>
    </div>

    <!-- Two items - side by side -->
    <div v-else-if="mediaItems.length === 2" class="grid grid-cols-2 gap-4">
      <template v-for="(item, i) in mediaItems.slice(0, 2)" :key="i">
        <div v-if="item" class="relative aspect-square">
          <TweetMediaItem
            :item="item"
            class="w-full h-full rounded-2xl overflow-hidden"
            @click="openGallery(i)"
            @play="$emit('videoPlay', i)"
          />
        </div>
      </template>
    </div>

    <!-- Three items - 2 stacked left, 1 full height right -->
    <div v-else-if="mediaItems.length === 3" class="grid grid-cols-2 gap-4">
      <div class="grid grid-rows-2 gap-4">
        <template v-for="(item, i) in mediaItems.slice(0, 2)" :key="i">
          <div v-if="item" class="relative aspect-square">
            <TweetMediaItem
              :item="item"
              class="w-full h-full rounded-2xl overflow-hidden"
              @click="openGallery(i)"
              @play="$emit('videoPlay', i)"
            />
          </div>
        </template>
      </div>
      <div v-if="mediaItems[2]" class="relative aspect-[9/19]">
        <TweetMediaItem
          :item="mediaItems[2]"
          class="w-full h-full rounded-2xl overflow-hidden"
          @click="openGallery(2)"
          @play="$emit('videoPlay', 2)"
        />
      </div>
    </div>

    <!-- Four items - 2x2 grid -->
    <div v-else-if="mediaItems.length === 4" class="grid grid-cols-2 gap-4">
      <template v-for="(item, i) in mediaItems" :key="i">
        <div v-if="item" class="relative aspect-square">
          <TweetMediaItem
            :item="item"
            class="w-full h-full rounded-2xl overflow-hidden"
            @click="openGallery(i)"
            @play="$emit('videoPlay', i)"
          />
        </div>
      </template>
    </div>

    <!-- Gallery Modal -->
    <ImageViewer
      v-if="isGalleryOpen"
      :is-open="isGalleryOpen"
      :media-items="mediaItems"
      :initial-index="selectedIndex"
      @close="closeGallery"
    />
  </div>
</template>

<script setup lang="ts">
import type { MediaItem } from '@/stores/interfaces'
import { ref } from 'vue'
import TweetMediaItem from './TweetMediaItem.vue'
import ImageViewer from '@/components/ImageViewer.vue'

defineProps<{
  mediaItems: MediaItem[]
}>()

defineEmits<{
  videoPlay: [index: number]
}>()

const isGalleryOpen = ref(false)
const selectedIndex = ref(0)

function openGallery(index: number) {
  selectedIndex.value = index
  isGalleryOpen.value = true
}

function closeGallery() {
  isGalleryOpen.value = false
}
</script>
